/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Helper: Safe Money Formatter


// function accountOpenTab(evt, tabName) {
//   console.log("Tab clicked: " + tabName); // Debugging ke liye

//   // 1. Saare contents ko select karo
//   var i, tabcontent, tablinks;
//   tabcontent = document.getElementsByClassName("tab-content");
  
//   // Sabko hide karo aur active class hatao
//   for (i = 0; i < tabcontent.length; i++) {
//     tabcontent[i].style.display = "none";
//     tabcontent[i].classList.remove("active");
//   }

//   // 2. Saare buttons ko select karo
//   tablinks = document.getElementsByClassName("tab-btn");
  
//   // Sab buttons se active class hatao (Strict removal)
//   for (i = 0; i < tablinks.length; i++) {
//     tablinks[i].classList.remove("active");
//   }

//   // 3. Jo tab click kiya hai use dikhao
//   var targetTab = document.getElementById(tabName);
//   if (targetTab) {
//     targetTab.style.display = "block";
//     targetTab.classList.add("active");
//     console.log("Showing tab: " + tabName);
//   } else {
//     console.error("Tab ID not found: " + tabName);
//   }

//   // 4. Clicked button par active class lagao
//   evt.currentTarget.classList.add("active");
// }

// Page load par sirf pehla tab dikhe ye ensure karne ke liye
// document.addEventListener("DOMContentLoaded", function() {
//   var loginForm = document.getElementById('login-form');
//   if(loginForm) {
//     loginForm.style.display = "block";
//   }
// });




// document.querySelectorAll(".tab-btn").forEach(button => {

//   button.addEventListener("click", function(){

//     let tabName = this.dataset.tab;
// console.log('tabName');
// console.log(tabName);


//     document.querySelectorAll(".tab-content").forEach(tab=>{
//       tab.classList.remove("active");
//     });

//     document.querySelectorAll(".tab-btn").forEach(btn=>{
//       btn.classList.remove("active");
//     });

//     document.getElementById(tabName).classList.add("active");
//     this.classList.add("active");

//   });
//   });




  
function formatMoney(cents) {
  // Check if Shopify object and money_format exist to avoid throwing errors
  var format = (window.Shopify && Shopify.money_format) || '£{{amount}}';
  var amount = (cents / 100).toFixed(2);
  
  if (format.includes('{{amount}}')) {
    return format.replace('{{amount}}', amount);
  } else if (format.includes('{{amount_with_comma_separator}}')) {
    return format.replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
  } else if (format.includes('{{amount_no_decimals}}')) {
    return format.replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }
  return '£' + amount;
}

// 1. Search Bar Logic
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.getElementById('search-input-field');
  const clearBtn = document.getElementById('clear-search');
    
  if (searchInput && clearBtn) {
    searchInput.addEventListener('input', function() {
      clearBtn.style.display = this.value.length > 0 ? 'block' : 'none';
    });

    clearBtn.addEventListener('click', function() {
      searchInput.value = '';
      this.style.display = 'none';
      searchInput.focus();
      
      const resultsContainer = document.querySelector('.search-bar__results');
      const resultsInner = document.querySelector('.search-bar__results-inner');
      
      if (resultsContainer) resultsContainer.setAttribute('aria-hidden', 'true');
      if (resultsInner) resultsInner.innerHTML = '';
    });
  }
});

// 2. Variant Change Logic (Consolidated)




document.addEventListener('variant:changed', function(event) {
  const variant = event.detail ? event.detail.variant : null;
  const priceList = document.querySelector('.price-list');
  
  if (!variant || !priceList) return; // Guard clause

  // Update Price HTML
  let priceHTML = '';
  if (variant.compare_at_price > variant.price) {
    priceHTML = `
      <span class="price price--highlight">
        <span class="visually-hidden">Sale price</span>
        <div class="price-value">${formatMoney(variant.price)}</div>
      </span>
      <span class="price price--compare">
        <span class="visually-hidden">Regular price</span>
        <div class="price-value">${formatMoney(variant.compare_at_price)}</div>
      </span>`;
  } else {
    priceHTML = `
      <span class="price">
        <span class="visually-hidden">Price</span>
        <div class="price-value">${formatMoney(variant.price)}</div>
      </span>`;
  }
  priceList.innerHTML = priceHTML;
  
  // Update Hidden Inputs
  const variantInputs = document.querySelectorAll('input[name="id"]');
  variantInputs.forEach(input => { if(input) input.value = variant.id; });
  
  // Update Add to Cart Button
  const addToCartButton = document.querySelector('.product-form__add-button');
  if (addToCartButton) {
    const isAvailable = variant.available;
    addToCartButton.disabled = !isAvailable;
    addToCartButton.classList.toggle('button--disabled', !isAvailable);
    
    const iconElement = addToCartButton.querySelector('svg');
    const label = isAvailable 
      ? (variant.template_suffix === 'pre-order' ? 'Pre-order' : 'Add to cart')
      : 'Sold out';

    if (iconElement) {
      addToCartButton.innerHTML = '';
      addToCartButton.appendChild(iconElement.cloneNode(true));
      addToCartButton.insertAdjacentText('beforeend', label);
    } else {
      addToCartButton.textContent = label;
    }
  }
});

// 3. AJAX Add to Cart Logic
// document.addEventListener('mousedown', function(event) {
//   const addButton = event.target.closest('.product-form__add-button');
//   if (!addButton || addButton.disabled) return;

//   const form = document.querySelector('.product-form') || 
//                document.querySelector('form[action*="/cart/add"]');
  
//   if (form) {
//     const variantId = form.querySelector('input[name="id"]')?.value;
//     const quantity = form.querySelector('input[name="quantity"]')?.value || 1;
    
//     if (variantId) {
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
//         body: JSON.stringify({ id: variantId, quantity: parseInt(quantity) })
//       })
//       .then(response => response.json())
//       .then(data => {
//         document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
//       })
//       .catch(error => console.error('Cart Error:', error));
//     }
//   }
// });
